import { Cart, CartLineInput, CartLineUpdateInput } from './shopify';
import {
  API_URLS,
  TypeResponseError,
  TypeResponseSuccess,
  getJSONData,
  parseErrorMessage,
} from '@/lib/api/config';
import { getAuthTokenClient } from '@/utils/helpers';
import { noticeError } from '@/utils/newrelicHelpers';

export type TypeCartResponseSuccess = TypeResponseSuccess<Cart>;

export async function addToCart(
  lines: CartLineInput[],
  quantity: number,
  queryParams = {},
) {
  const body = JSON.stringify({ lines, quantity });
  const queryParamsString = new URLSearchParams(queryParams).toString();
  const config = {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthTokenClient(),
    },
  };

  const response = await fetch(
    `${API_URLS.CART_SERVICE}/add${
      queryParamsString ? `?${queryParamsString}` : ''
    }`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    const errorMessage = await parseErrorMessage(response);
    noticeError('Product add to cart error', errorMessage);
    return {
      ok,
      errorMessage,
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeCartResponseSuccess;
}

export async function removeFromCart(
  lineIds: string[],
  queryParams = {},
  signal?: AbortSignal,
) {
  const body = JSON.stringify({ lineIds });
  const queryParamsString = new URLSearchParams(queryParams).toString();
  const config = {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthTokenClient(),
    },
    signal,
  };

  const response = await fetch(
    `${API_URLS.CART_SERVICE}/remove${
      queryParamsString ? `?${queryParamsString}` : ''
    }`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeCartResponseSuccess;
}

export async function updateCart(
  lines: CartLineUpdateInput[],
  queryParams = {},
  signal?: AbortSignal,
) {
  const body = JSON.stringify({ lines });
  const queryParamsString = new URLSearchParams(queryParams).toString();
  const config = {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthTokenClient(),
    },
    signal,
  };

  const response = await fetch(
    `${API_URLS.CART_SERVICE}/update${
      queryParamsString ? `?${queryParamsString}` : ''
    }`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    const errorMessage = await parseErrorMessage(response);
    noticeError('Cart update error', errorMessage);
    return {
      ok,
      errorMessage,
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeCartResponseSuccess;
}
